import { TradeTapeItem } from '@paradigm/features/src/unified-rfqs/entities/drfq/trades';
import { formatProductPrice } from '@paradigm/features/src/unified-rfqs/ui/rfqs/rfqs-functions';
import LegPricesTable from '../components/LegPricesTable';

export default function TradeLegPricesTable({
  trade,
}: {
  trade: TradeTapeItem;
}) {
  return <LegPricesTable prices={trade.legs.map(processLegPrices)} />;
}

function processLegPrices(leg: TradeTapeItem['legs'][number]) {
  const price = formatProductPrice(leg.price ?? null, leg.product_code);

  return {
    ask: leg.side === 'SELL' ? price : null,
    bid: leg.side === 'BUY' ? price : null,
  };
}
